import { forwardRef } from 'react';

import PropTypes from 'prop-types';

import ZuiTextField from '@zenbusiness/zui/TextField';

const TextField = forwardRef((props, forwardedRef) => {
  const { error, helperText, ...delegated } = props;

  const isError = Boolean(error);
  const helperTextValue = isError ? error?.message : helperText;
  const helperTextProps = isError ? { role: 'alert' } : undefined;

  return (
    <ZuiTextField
      error={isError}
      FormHelperTextProps={helperTextProps}
      helperText={helperTextValue}
      {...delegated}
      ref={forwardedRef}
    />
  );
});

TextField.displayName = 'TextField';

TextField.propTypes = {
  error: PropTypes.oneOfType([PropTypes.instanceOf(Error), PropTypes.shape({})]),
  helperText: PropTypes.string
};

export default TextField;
